export default "__VITE_ASSET__B8O2FjLu__"